import { render, staticRenderFns } from "./TelLogin.vue?vue&type=template&id=2772c7ae"
import script from "./TelLogin.vue?vue&type=script&lang=js"
export * from "./TelLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports